import { render, staticRenderFns } from "./Devize_factura_multipla_dialog.vue?vue&type=template&id=c3dc6fa8&scoped=true"
import script from "./Devize_factura_multipla_dialog.vue?vue&type=script&lang=js"
export * from "./Devize_factura_multipla_dialog.vue?vue&type=script&lang=js"
import style0 from "./Devize_factura_multipla_dialog.vue?vue&type=style&index=0&id=c3dc6fa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dc6fa8",
  null
  
)

export default component.exports